import { Arrays } from "ext/array";
import { createMoveForwardIndices, createMoveToFrontIndices, createSendBackwardIndices, createSendToBackIndices, reorder } from "ordering/reorder";
import appStore from "store/store";
export class ReorderItems {
    constructor(from, to) {
        this.from = from;
        this.to = to;
    }
    static create(ids, op) {
        let indices = getIndices(ids);
        let destIndices = (() => {
            switch (op) {
                case "sendBackward": return createSendBackwardIndices(indices);
                case "sendToBack": return createSendToBackIndices(indices);
                case "bringForward": return createMoveForwardIndices(indices, appStore.items().length);
                case "bringToFront": return createMoveToFrontIndices(indices, appStore.items().length);
            }
        })();
        // If this results in no changes, dont' return a command.
        if (Arrays.shallowStrictEquals(indices, destIndices))
            return;
        return new ReorderItems(indices, destIndices);
    }
    execute() {
        appStore.dispatchFn("Reorder", (store) => {
            return Object.assign(Object.assign({}, store), { items: reorder(store.items, this.from, this.to) });
        });
    }
    undo() {
        appStore.dispatchFn("Reorder", (store) => {
            return Object.assign(Object.assign({}, store), { items: reorder(store.items, this.to, this.from) });
        });
    }
}
export class SendToBack {
    static createFor(id) {
        // Determine the index of the element.
        let index = getIndex(id, 0);
        if (index == 0)
            return;
        return new SendToBack(index);
    }
    constructor(index) {
        this.index = index;
    }
    execute() {
        appStore.dispatchFn("SendToBack", (state) => {
            let newItems = [...state.items];
            let toMove = newItems.splice(this.index, 1);
            newItems.unshift(toMove[0]);
            return Object.assign(Object.assign({}, state), { items: newItems });
        });
    }
    undo() {
        appStore.dispatchFn("Undo-SendToBack", (state) => {
            let newItems = [...state.items];
            // Pop from the front and insert into original index position.
            let toMove = newItems.shift();
            newItems.splice(this.index, 0, toMove);
            return Object.assign(Object.assign({}, state), { items: newItems });
        });
    }
}
export class BringToFront {
    static createFor(id) {
        // Determine the index of the element.
        let highestIndex = appStore.items().length - 1;
        let index = getIndex(id, highestIndex);
        if (index == highestIndex)
            return;
        return new BringToFront(index);
    }
    constructor(index) {
        this.index = index;
    }
    execute() {
        appStore.dispatchFn("BringToFront", (state) => {
            let newItems = [...state.items];
            let toMove = newItems.splice(this.index, 1);
            newItems.push(toMove[0]);
            return Object.assign(Object.assign({}, state), { items: newItems });
        });
    }
    undo() {
        appStore.dispatchFn("Undo-BrintToFront", (state) => {
            let newItems = [...state.items];
            // Pop from the front and insert into original index position.
            let toMove = newItems.pop();
            newItems.splice(this.index, 0, toMove);
            return Object.assign(Object.assign({}, state), { items: newItems });
        });
    }
}
export class BringForward {
    static createFor(id) {
        // Determine the index of the element.
        let highestIndex = appStore.items().length - 1;
        let index = getIndex(id, highestIndex);
        if (index == highestIndex)
            return;
        return new BringForward(index);
    }
    constructor(index) {
        this.index = index;
    }
    execute() {
        appStore.dispatchFn("BringForward", (state) => {
            let newItems = [...state.items];
            let toMove = newItems.splice(this.index, 1);
            newItems.splice(this.index + 1, 0, toMove[0]);
            return Object.assign(Object.assign({}, state), { items: newItems });
        });
    }
    undo() {
        appStore.dispatchFn("Undo-BringForward", (state) => {
            let newItems = [...state.items];
            // Pop from the front and insert into original index position.
            let toMove = newItems.splice(this.index + 1, 1);
            newItems.splice(this.index, 0, toMove[0]);
            return Object.assign(Object.assign({}, state), { items: newItems });
        });
    }
}
export class SendBackward {
    static createFor(id) {
        // Determine the index of the element.
        let index = getIndex(id, 0);
        if (index == 0)
            return;
        return new SendBackward(index);
    }
    constructor(index) {
        this.index = index;
    }
    execute() {
        appStore.dispatchFn("SendBackwards", (state) => {
            let newItems = [...state.items];
            let toMove = newItems.splice(this.index, 1);
            newItems.splice(this.index - 1, 0, toMove[0]);
            return Object.assign(Object.assign({}, state), { items: newItems });
        });
    }
    undo() {
        appStore.dispatchFn("Undo-SendBackwards", (state) => {
            let newItems = [...state.items];
            // Pop from the front and insert into original index position.
            let toMove = newItems.splice(this.index - 1, 1);
            newItems.splice(this.index, 0, toMove[0]);
            return Object.assign(Object.assign({}, state), { items: newItems });
        });
    }
}
function getIndex(id, notFound) {
    let items = appStore.items();
    for (var i = 0; i < items.length; i++) {
        let item = items[i];
        if (item.id == id) {
            return i;
        }
    }
    // This should never happen.
    return notFound;
}
function getIndices(ids) {
    let items = appStore.items();
    let indices = [];
    for (var i = 0; i < items.length; i++) {
        let item = items[i];
        if (ids.indexOf(item.id) > -1) {
            indices.push(i);
        }
    }
    return indices;
}
